import React from 'react';
import { Check } from 'lucide-react';

const stepLabels = ['Project Photo', 'Leverage Questions', 'Contact Info'];

export default function QuoteProgressBar({ currentStep, totalSteps }: { currentStep: number; totalSteps: number }) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-[#666] font-500">Step {currentStep} of {totalSteps}</span>
        <span className="text-xs text-[#666] font-500">{stepLabels[currentStep - 1]}</span>
      </div>
      <div className="w-full bg-[#1A1A1A] rounded-full h-1.5 mb-4">
        <div
          className="bg-blue-600 h-1.5 rounded-full transition-all duration-500 ease-out"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
      <div className="flex items-center gap-0">
        {Array.from({ length: totalSteps }).map((_, i) => {
          const stepNum = i + 1;
          const isDone = stepNum < currentStep;
          const isCurrent = stepNum === currentStep;
          return (
            <React.Fragment key={`step-${stepNum}`}>
              <div className={`
                flex items-center justify-center w-7 h-7 rounded-full text-xs font-700 flex-shrink-0 transition-all duration-300
                ${isDone ? 'bg-blue-600 text-white' : isCurrent ? 'bg-blue-600/20 border-2 border-blue-600 text-blue-400' : 'bg-[#1A1A1A] text-[#444]'}
              `}>
                {isDone ? <Check size={12} /> : stepNum}
              </div>
              {i < totalSteps - 1 && (
                <div className={`flex-1 h-0.5 mx-1 transition-all duration-500 ${isDone ? 'bg-blue-600' : 'bg-[#1A1A1A]'}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}